module.exports = __webpack_public_path__ + "img/Gallery_2_36.e5ab3d7f.jpeg";